export const ClaimListStyles = {
  headerStyles: {
    display: "flex",
    marginTop: "25px",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  claimCardStyle: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: "10px",
    "@media(max-width: 992px)": {
      gridTemplateColumns: "1fr",
    },
  },
};
